module.exports = __webpack_public_path__ + "static/assets/d15ff2adc7daddbb8569643785cdf7a1.png";